import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'customer-report',
    templateUrl: './customer-report-mobile.component.html',
    styleUrls: ['./customer-report-mobile.component.css']
})
export class CustomerReportMobileComponent implements OnInit {

    data: any;

    constructor() {
        this.data = {
            threatLevel: 1,
            alerts: [
                {
                    target: 'Server 1',
                    value: 123,
                    level: 4
                },
                {
                    target: 'Server 2',
                    value: 269,
                    level: 7
                },
                {
                    target: 'Device A',
                    value: 60,
                    level: 2
                },
                {
                    target: 'Device B',
                    value: 338,
                    level: 9
                },
                {
                    target: 'Device C',
                    value: 82,
                    level: 3
                }
            ],
            countries: [
                {
                    name: 'USA',
                    code: 'us',
                    value: 165
                },
                {
                    name: 'Greece',
                    code: 'gr',
                    value: 91
                },
                {
                    name: 'Australia',
                    code: 'au',
                    value: 54
                },
                {
                    name: 'Ukraine',
                    code: 'ua',
                    value: 33
                },
                {
                    name: 'Malaysia',
                    code: 'my',
                    value: 31
                }
            ]
        };
    }

    ngOnInit() {
    }

    range(n) {
        return new Array(n).fill(1);
    }

}



// WEBPACK FOOTER //
// /app/src/app/containers/customer-report-mobile/customer-report-mobile.component.ts